import { RequestOptions, Headers } from '@angular/http';

//you can move this class to a better place
export class GlobalHttpOptions extends RequestOptions {
    constructor() {
        super({
            withCredentials: true
        });
    }
}